import { ShortCode } from '@highereducation/wordpress';
import {
  TimelineEventDescription,
  TimelineEventDescriptionProps,
  Text,
} from '@highereducation/hen-ui';

interface TimelineEventDescriptionShortcodeProps
  extends TimelineEventDescriptionProps {
  children: React.ReactNode;
  index: number;
  'is-last': string;
  [key: string]: any;
}

export const TimelineEventDescriptionShortcode: ShortCode<TimelineEventDescriptionShortcodeProps> =
  {
    component: ({ children, 'is-last': isLast, index }) => {
      return (
        <TimelineEventDescription
          index={index}
          isLast={isLast == 'true' ? true : false}
        >
          {children}
        </TimelineEventDescription>
      );
    },
  };
